import { useState, useEffect } from "react";
import { branchProductWiseDeposits, branchWiseDeposits } from "./SavingService";
import { Card, Form, Row, Col, Select, Button, Spin, DatePicker } from 'antd';
import { errHandler } from '../../helper/helper';
import { generateMonthlyAllWasamReport } from "./SavingService";
import { generateBlob } from "../../Utils/CreateBlob";
const { RangePicker } = DatePicker;




const { Option, OptGroup } = Select;

const MonthlyDormantDeposits = ({
    loginPlaceId,
    products,
    districtData,
    districtName,
    branchId,
    divisionalId,
    wasamData,
}) => {

    const [selectedDistricts, setSelectedDistricts] = useState([]);
    const [selectedDivisionalAreas, setSelectedDivisionalAreas] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedDates, setSelectedDates] = useState([]);
    const [selectedWasam, setSelectedWasam] = useState([]);
    const [availableDivisionalAreas, setAvailableDivisionalAreas] = useState([]);
    const [availableBranches, setAvailableBranches] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let filteredDivisionalAreas = [];
        console.log(districtData)

        console.log(selectedDistricts)
        if (loginPlaceId === "2" && divisionalId) {
            // Divisional-level user: find the matching divisional area from any district
            filteredDivisionalAreas = districtData
                .flatMap(d => d.divisionalAreaDtoList || [])
                .filter(div => div.divAId === divisionalId);

            setSelectedDivisionalAreas([divisionalId]); // auto-select the one they're assigned to
            console.log("Divisional Area for divisional user:", filteredDivisionalAreas);
        } else {
            // Normal case: based on selected districts
            filteredDivisionalAreas = districtData
                .filter(d => selectedDistricts.includes(d.districtId))
                .flatMap(d => d.divisionalAreaDtoList || []);

            // Clean up selected divisional areas
            setSelectedDivisionalAreas(prev =>
                prev.filter(did =>
                    filteredDivisionalAreas.some(d => d.divAId === did)
                )
            );
        }

        setAvailableDivisionalAreas(filteredDivisionalAreas); // <- you should set this too

    }, [selectedDistricts, districtData, loginPlaceId, divisionalId]);

    //update available branches based on selected divisional areas
    useEffect(() => {
        const filteredBranches = districtData
            .flatMap(d => d.divisionalAreaDtoList || [])
            .filter(div => selectedDivisionalAreas.includes(div.divAId))
            .flatMap(div => div.branchDtoList || []);

        setAvailableBranches(filteredBranches);

        // Clean up selected branches
        setSelectedBranches(prev =>
            prev.filter(bid =>
                filteredBranches.some(b => b.id === bid)
            )
        );
    }, [selectedDivisionalAreas, districtData]);

    const generateAllWasamReport = () => {
        console.log(branchId, selectedBranches, loginPlaceId);
        let branch = loginPlaceId === "2"|| loginPlaceId === "3" || loginPlaceId === "4" ? selectedBranches : branchId;
            const [startDate, endDate] = selectedDates;
            let data = {
                branchId: branch,
                selectedDate: startDate,
                endDate: endDate,
                wasamIdList: selectedWasam,
                productIdList: selectedProducts
            }
            setLoading(true);
            generateMonthlyAllWasamReport(data).then((res) => {
                generateBlob(res.data)
            }).catch(err => {
                errHandler(err)
            }).finally(() => {
                setLoading(false);
            })
        }






    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">
                    <Row gutter={[16, 16]}>
                        {/* District auto complete */}
                        {(loginPlaceId === "3" || loginPlaceId === "4") && (
                            <Col span={24}>
                                <Form.Item label="Select Districts">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select districts"
                                        style={{ width: '100%' }}
                                        value={selectedDistricts}
                                        onChange={setSelectedDistricts}
                                    >
                                        {districtData
                                            .filter(d => loginPlaceId === "4" ? d.districtName === districtName : true)
                                            .map(d => (
                                                <Option key={d.districtId} value={d.districtId}>
                                                    🏙️ {d.districtName}
                                                </Option>
                                            ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}
                        {(loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "2") && (
                            <Col span={24}>
                                <Form.Item label="Select Divisional Areas">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select divisional areas"
                                        style={{ width: '100%' }}
                                        value={selectedDivisionalAreas}
                                        onChange={setSelectedDivisionalAreas}
                                    // disabled={selectionScope !== 'divisional' && selectionScope !== 'branch'}
                                    >
                                        {availableDivisionalAreas
                                            .filter(d => loginPlaceId === "2" ? d.divAId === divisionalId : true)
                                            .map(d => (
                                                <Option key={d.divAId} value={d.divAId}>
                                                    🏙️ {d.divAIdName}
                                                </Option>
                                            ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}
                        {(loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "2") && (
                            <Col span={24}>
                                <Form.Item label="Select Branch">
                                    <Select
                                        mode="single"
                                        placeholder="Select branches"
                                        style={{ width: '100%' }}
                                        value={selectedBranches}
                                        onChange={(values) => {
                                       setSelectedBranches(values);
                                        }}
                                        disabled={availableBranches.length === 0}
                                    >

                                        {availableBranches.map(branch => (
                                            <Option key={branch.id} value={branch.id}>
                                                🏢 {branch.branchName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}
                        {loginPlaceId == "1" && (
                            <Col span={24}>
                                <Form.Item label="Wasam">
                                    <Select
                                        mode="multiple" value={selectedWasam} onChange={(values) => {
                                            if (values.includes('ALL')) {
                                                setSelectedWasam(wasamData.map(b => b.wastId));
                                            } else {
                                                setSelectedWasam(values);
                                            }
                                        }}
                                        disabled={wasamData.length === 0} style={{ width: '100%' }}>
                                        <Option value="ALL">All Wasam</Option>
                                        {wasamData.map((wasam) => (
                                            <Option key={wasam.wastId} value={wasam.wastId}>
                                                🏙️  {wasam.wasName}--{wasam.wasName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}

                        <Col span={24}>
                            <Form.Item label="Select Date">
                                <RangePicker onChange={(date) => setSelectedDates(date)} style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>

                        {/* Multi-select product */}
                        <Col span={24}>
                            <Form.Item label="Select Products">
                                <Select
                                    mode="multiple"
                                    allowClear
                                    placeholder="Select products"
                                    style={{ width: '100%' }}
                                    value={selectedProducts}
                                    onChange={(values) => {
                                        if (values.includes('ALL')) {
                                            setSelectedProducts(products.map(b => b.productId));
                                        } else {
                                            setSelectedProducts(values);
                                        }
                                    }}
                                    disabled={products.length === 0}
                                // onChange={setSelectedProducts}
                                >
                                    <Option key="ALL" value="ALL">
                                        🔘 Select All Products
                                    </Option>
                                    {products.map(product => (
                                        <Option key={product.productId} value={product.productId}>
                                            {product.productName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                       

                        {/* Submit button */}
                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    onClick={generateAllWasamReport}
                                    disabled={loading}
                                    className="generate-btn"
                                    style={{ textAlign: 'right' }}
                                >
                                    {loading ? <Spin /> : 'Generate Report'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );


}
export default MonthlyDormantDeposits